// extracted by mini-css-extract-plugin
export default {"wrapper":"CodeEditorToolbar_wrapper__Fv1ap","root":"CodeEditorToolbar_root__fR5SL","alignCenter":"CodeEditorToolbar_alignCenter__rAqSl"};